import React, { useState } from 'react'
import { Card, CardContent, CardHeader, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { StackedBarChart } from '../../../charts/BarChart'
import { STATUS_COLORS } from '../../../charts/colors'
import MaterialTable from '../../../../common/MaterialTable'
import { numberPrecision } from '../../../../helpers/UtilityHelper'

const NDRDispositionReport = ({ data = [] }) => {
    const [view, setView] = useState('chart')

    if (!data || data.length === 0) return null

    const chartOptions = {
        xaxis: 'name',
        data: [
            { dataKey: 'delivered', label: 'Delivered', fill: STATUS_COLORS.DELIVERED },
            { dataKey: 'rto', label: 'RTO', fill: STATUS_COLORS.RTO },
            { dataKey: 'lost', label: 'Lost', fill: STATUS_COLORS.LOST },
            { dataKey: 'open', label: 'Open', fill: STATUS_COLORS.INTRANSIT },
        ],
        stackId: 'a',
        showLabels: true,
        legendAlign: 'left',
    }

    const columns = [
        { label: 'Period', value: 'name', align: 'left' },
        { label: 'Delivered', value: (row) => `${row.delivered} (${numberPrecision(row.deliveredPerc)}%)` },
        { label: 'RTO', value: (row) => `${row.rto} (${numberPrecision(row.rtoPerc)}%)` },
        { label: 'Lost', value: (row) => `${row.lost} (${numberPrecision(row.lostPerc)}%)` },
        { label: 'Open', value: (row) => `${row.open} (${numberPrecision(row.openPerc)}%)` },
        { label: 'Total', value: 'total' },
    ]

    return (
        <Card elevation={1}>
            <CardHeader
                title="NDR Disposition Report"
                subheader="Final outcome of NDR shipments across periods"
                action={
                    <ToggleButtonGroup
                        value={view}
                        exclusive
                        size="small"
                        onChange={(_e, v) => v && setView(v)}
                    >
                        <ToggleButton value="chart">Chart</ToggleButton>
                        <ToggleButton value="table">Table</ToggleButton>
                    </ToggleButtonGroup>
                }
            />
            <CardContent>
                {view === 'chart' ? (
                    <StackedBarChart data={data} chartOptions={chartOptions} />
                ) : (
                    <MaterialTable columns={columns} rows={data} />
                )}
            </CardContent>
        </Card>
    )
}

export default NDRDispositionReport
